(() => {
  const card = document.querySelector('[data-tb-sound]');
  const tab = document.querySelector('[data-tb-sound-tab]');
  if (!card || !tab) return;
  const banner = document.querySelector('[data-tb-sound-banner]');
  const mobile = matchMedia('(max-width:749px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  // Mobile banner is server-rendered beneath shipping; never relocate it after paint.
  let expanded = false;
  let animation;
  let revision = 0;
  const overlayOpen = () => Boolean(document.querySelector('cart-drawer.active, cart-notification.active, dialog[open], details[open].menu-opening'));
  const render = () => {
    card.hidden = mobile.matches || !expanded || overlayOpen();
    tab.hidden = mobile.matches || expanded || overlayOpen();
    if (banner) banner.hidden = !mobile.matches || overlayOpen();
    tab.setAttribute('aria-expanded', String(expanded));
    document.body.classList.toggle('tb-sound-visible', !card.hidden);
  };
  const move = async (element, opening, panel) => {
    const token = ++revision;
    animation?.cancel();
    if (reduced.matches || !element.animate || (!panel && mobile.matches)) return;
    const rest = panel && !mobile.matches ? 'translateY(-50%)' : (!panel && !mobile.matches ? 'translateY(-50%)' : 'none');
    const away = mobile.matches ? 'translateY(28px)' : 'translate(110%, -50%)';
    const frames = [{ transform: away, opacity: 0 }, { transform: rest, opacity: 1 }];
    animation = element.animate(opening ? frames : [...frames].reverse(), { duration: opening ? 480 : 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
    try { await animation.finished; } catch { /* Interrupted by a new action or overlay. */ }
    if (token === revision) { animation?.cancel(); animation = null; }
  };
  const close = async () => {
    if (!expanded) return;
    expanded = false;
    card.inert = true;
    const exit = move(card, false, true);
    const token = revision;
    await exit;
    if (token !== revision || expanded) return;
    render();
    card.inert = false;
    if (!tab.hidden) { tab.focus({ preventScroll: true }); move(tab, true, false); }
  };
  tab.addEventListener('click', () => {
    if (mobile.matches) return;
    expanded = true;
    card.inert = false;
    render();
    move(card, true, true);
    card.querySelector('.tb-sound__close').focus({ preventScroll: true });
  });
  card.querySelector('.tb-sound__close').addEventListener('click', close);
  card.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
  });
  const reconcile = () => {
    ++revision;
    animation?.cancel();
    card.inert = false;
    render();
  };
  document.querySelectorAll('cart-drawer, cart-notification, dialog, details').forEach(overlay => {
    new MutationObserver(reconcile).observe(overlay, { attributes: true, attributeFilter: ['class', 'open'] });
  });
  mobile.addEventListener('change', () => { expanded = false; reconcile(); });
  reduced.addEventListener('change', reconcile);
  render();
  if (!tab.hidden) move(tab, true, false);
})();
